/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchBasketsByOrderRefQueryVariables = Types.Exact<{
  num?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  start?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sortBy?: Types.InputMaybe<Types.BasketSearchSortType>;
  sortDirection?: Types.InputMaybe<Types.BasketSearchSortDirection>;
  orderReferenceNumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SearchBasketsByOrderRefQuery = { searchBaskets?: { totalResultCount?: number | null, baskets?: Array<{ basketId: string, orderReferenceNumber: string, clientReferenceNumber?: string | null, creationTime: any, status?: string | null, user?: { userId: string, displayName: string } | null, summary?: { totalPiecesQuantity: number, totalValueByCurrency?: any | null } | null, basketAccounts?: Array<{ address?: { name?: string | null } | null } | null> | null } | null> | null } | null };

export const SearchBasketsByOrderRefDocument = gql`
    query SearchBasketsByOrderRef($num: Int, $start: Int, $sortBy: BasketSearchSortType, $sortDirection: BasketSearchSortDirection, $orderReferenceNumber: String) {
  searchBaskets(
    num: $num
    start: $start
    sortBy: $sortBy
    sortDirection: $sortDirection
    orderReferenceNumber: $orderReferenceNumber
  ) {
    totalResultCount
    baskets {
      basketId
      orderReferenceNumber
      clientReferenceNumber
      creationTime
      status
      user {
        userId
        displayName
      }
      summary {
        totalPiecesQuantity
        totalValueByCurrency
      }
      basketAccounts {
        address {
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchBasketsByOrderRefGQL extends Apollo.Query<SearchBasketsByOrderRefQuery, SearchBasketsByOrderRefQueryVariables> {
    document = SearchBasketsByOrderRefDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }